import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MetabaseQuestionComponent } from './metabase-question.component';

const routes: Routes = [
  {
    path: '',
    component: MetabaseQuestionComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MetabaseQuestionRoutingModule {}
